import http from "../../helpers/axiosClient";

export const getCardProductUser = (param, callback) => {
    http.get("/Users/Cart/ListCardProductUser",{params: param})
        .then(response => {
            if (response.statusCode === 200) {
                callback(response.data);
            } else {
                console.error("ApiDetail:" + response.message)
            }
        })
        .catch(e => {
            console.log(e)
        })
}

export const getCartProductUser = async (param, callback) => {
    http.get("/Products/Product/ApiDetailProductSimilars?"+param,)
        .then(response => {
            if (response.statusCode === 200) {
                callback(response.data);
            } else {
                console.error("ApiDetail:" + response.message)
            }
        })
        .catch(e => {
            console.log(e)
        })
}

export const changeCardProductUser = (data, callback) => {
    http.patch("/Users/Cart/ChangeQuantity",data)
        .then(callback)
        .catch(e => {
            console.log(e)
        })

}

export const removeCardProduct = (productSimilarId, callback) => {
    showLoading();
    http.delete("/Users/Cart/RemoveCard/"+productSimilarId)
        .then(response => {
            hideLoading();
            if (response.statusCode === 200) {
                callback();
            } else {
                console.error("ApiDetail:" + response.message)
            }
        })
        .catch(e => {
            hideLoading();
            console.log(e)
        })

}

export const checkoutProduct = (data, callback) => {
    http.post("/Users/Checkout",data)
        .then(callback)
        .catch(e => {
            console.log(e)
        })
}
